import { render } from "./UploadImages.vue?vue&type=template&id=4c737037&scoped=true"
import script from "./UploadImages.vue?vue&type=script&lang=js"
export * from "./UploadImages.vue?vue&type=script&lang=js"

import "./UploadImages.vue?vue&type=style&index=0&id=4c737037&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c737037"]])

export default __exports__